var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"form":_vm.form,"dialog":_vm.dialog,"booking":_vm.booking},on:{"save":_vm.onSave,"refresh":_vm.onRefresh,"update":_vm.onUpdate,"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }